"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledListTitle = exports.StyledListItem = exports.StyledList = void 0;
var _ykbStyledComponents = _interopRequireWildcard(require("../ykb-styled-components"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var StyledListItem = exports.StyledListItem = _ykbStyledComponents.default.li.withConfig({
  componentId: "ykb-ui__sc-8qq88d-0"
})(["color:", ";padding:", ";border-bottom:1px solid ", ";&:last-child{border-bottom:0;}"], function (props) {
  return props.theme.list.textColor;
}, function (props) {
  return props.theme.list.sizes[props.$size].padding;
}, function (props) {
  return props.theme.list.borderColor;
});
var StyledListTitle = exports.StyledListTitle = _ykbStyledComponents.default.span.withConfig({
  componentId: "ykb-ui__sc-8qq88d-1"
})(["font-weight:500;"]);
var StyledList = exports.StyledList = _ykbStyledComponents.default.ul.withConfig({
  componentId: "ykb-ui__sc-8qq88d-2"
})(["list-style:none;padding:0;", " ", ""], function (props) {
  return props.$bordered && (0, _ykbStyledComponents.css)(["border:1px solid ", ";"], function (props) {
    return props.theme.list.borderColor;
  });
}, function (props) {
  return props.$zebra && (0, _ykbStyledComponents.css)(["", "{border-bottom:1px solid transparent;background:", ";&:nth-child(2n-1){background:", ";}}"], StyledListItem, function (props) {
    return props.theme.color.neutral1;
  }, function (props) {
    return props.theme.list.backgroundColor;
  });
});